<template>
  <navigation-overlay class="nav-bar-root" :isOpen="isOpen" v-on:close="handleClose"/>
</template>

<script>
import NavigationOverlay from '../base-components/app-header/NavigationOverlay.vue';
import NavigationBus from '../event-bus/navigation-bus';
import Intercom from '../Intercom';

export default {
  name: 'NavBarRoot',
  components: {
    NavigationOverlay,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  created() {
    NavigationBus.$on('open', () => {
      document.body.classList.add('modal-open');
      Intercom.hideLauncher();
      this.isOpen = true;
    });
    document.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handleKeyup);
  },
  methods: {
    handleClose() {
      document.body.classList.remove('modal-open');
      Intercom.showLauncher();
      this.isOpen = false;
    },
    handleKeyup(e) {
      if (e.keyCode === 27) {
        this.handleClose();
      }
    },
  },
};

</script>

<style lang="scss" scoped>
  .nav-bar-root {
    z-index: 20;
  }

</style>



// WEBPACK FOOTER //
// src/modal/NavBarRoot.vue